import { Dispatch } from 'redux';
import { connect } from 'react-redux';

import CaseSession, { DispatchProps, OwnProps, StateProps } from './CaseSessionTab';
import { StoreState } from 'src/store/reducers';
import { getCase } from 'src/store/actions/case-actions';
import { createInvoice, getInvoices } from 'src/store/actions/invoice-actions';
import { createStatement, getStatementsDocs } from 'src/store/actions/case-actions';
import { getSeances, getSeancesList, getSeancesStatistics } from 'src/store/actions/seance-actions';

import { QueryParams } from '../../../../../../../../../types/grid';
import { toast } from 'react-toastify';
import { selectNameSerTypesDropDown } from 'src/store/selectors/service-types-selectors';
import { selectNameSerLocationsDropDown } from 'src/store/selectors/service-location-selectors';

function mapStateToProps(state: StoreState, ownProps: OwnProps): StateProps {
    return {
        caseCurrent: state.cases.current,
        baseConfig: state.app.baseConfig,
        inProgressInvoice: state.invoices.inProgress,
        inProgress: state.cases.inProgress,
        inProgressSeance: state.seances.inProgress,
        inProgressSeancesList: state.seancesList.inProgress,
        serviceTypes: selectNameSerTypesDropDown(state),
        serviceLocations: selectNameSerLocationsDropDown(state),
        statistics: state.seances.statistics,
        statementDocs: state.cases.statementDocs,
        seances: state.seances.data,
        seancesList: state.seancesList.data,
    };
}

function mapDispatchToProps(dispatch: Dispatch, ownProps: OwnProps): DispatchProps {
    return {
        getData: (id) => dispatch(getCase(id)),
        createStatementAction: (params, setPopup) => {
            return dispatch(
                createStatement(
                    params,
                    () => {
                        toast.success('Statement created successfully');
                        dispatch(
                            getStatementsDocs({
                                page: 1,
                                filters: {
                                    'statement.occasion.id': +ownProps.idCase,
                                    'periodStart[after]': ownProps.month.monthStart,
                                    'periodStart[before]': ownProps.month.monthEnd,
                                    'provider.id': +ownProps.providerUrlId,
                                },
                            }),
                        );
                        setPopup(false);
                    },
                    (err) => {
                        toast.error(err);
                        setPopup(false);
                    },
                ),
            );
        },
        createInvoiceAction: (params, setPopup) => {
            return dispatch(
                createInvoice(
                    params,
                    () => {
                        toast.success('Invoice created successfully');
                        dispatch(
                            getInvoices({
                                page: 1,
                                filters: {
                                    'occasion.id': +ownProps.idCase,
                                    'periodStart[after]': ownProps.month.monthStart,
                                    'periodStart[before]': ownProps.month.monthEnd,
                                    'provider.id': +ownProps.providerUrlId,
                                },
                            }),
                        );
                        setPopup(false);
                    },
                    (err) => {
                        toast.error(err);
                        setPopup(false);
                    },
                ),
            );
        },
        getDataSeance: (params: QueryParams) => dispatch(getSeances(params)),

        getSeancesList: (params: QueryParams) => dispatch(getSeancesList(params)),

        getStatistics: (params: any) => dispatch(getSeancesStatistics(params)),
    };
}

const CaseSessionTab = connect<StateProps, DispatchProps, OwnProps, StoreState>(
    mapStateToProps,
    mapDispatchToProps,
)(CaseSession);

export default CaseSessionTab;
